import { v4 as uuid } from 'uuid';

export type PatientId = string & { readonly __brand: 'PatientId' };
export type StructureSetId = string & { readonly __brand: 'StructureSetId' };
export type RoiId = string & { readonly __brand: 'RoiId' };

export const newPatientId = (): PatientId => uuid() as PatientId;
export const newStructureSetId = (): StructureSetId => uuid() as StructureSetId;
export const newRoiId = (): RoiId => uuid() as RoiId;

/**
 * Cast a known-valid GUID string to a branded ID.
 * Use only when the string is already known to be a valid GUID
 * (e.g., from connector hydration).
 */
export const asPatientId = (s: string): PatientId => s as PatientId;
export const asStructureSetId = (s: string): StructureSetId =>
    s as StructureSetId;
export const asRoiId = (s: string): RoiId => s as RoiId;
